import { RedirectCommand, Router, Routes, type UrlTree } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component';
import { AuthenticationService } from './core/services/auth.service';
import { inject } from '@angular/core';

export const routes: Routes = [
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [
      () => {
        const authService = inject(AuthenticationService);
        const router = inject(Router);
        return authService.session
          ? true
          : new RedirectCommand(router.parseUrl('/auth/sign-in'));
      },
    ],
    loadChildren: () =>
      import('./main/main.route').then((mod) => mod.MAIN_ROUTES),
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./main/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  { path: '**', redirectTo: '/' },
];
